(() => {
  const root = document.querySelector('.ers-p');
  if (!root) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const measureShell = () => root.style.setProperty('--ers-p-shell-height', `${Math.max(0, root.getBoundingClientRect().top + scrollY)}px`);
  measureShell();
  window.addEventListener('resize', measureShell, {passive: true});
  if ('IntersectionObserver' in window) {
    root.classList.add('ers-p--enhanced');
    const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); reveal.unobserve(entry.target); }
    }), {rootMargin: '0px 0px 80px 0px', threshold: .03});
    root.querySelectorAll('.ers-p__section-head, .ers-p__process-top, .ers-p__sourcing > article, .ers-p__project').forEach(node => {
      node.dataset.reveal = '';
      reveal.observe(node);
    });
  }
  const process = root.matches('[data-ers-projects-process]') ? root : null;
  if (process) {
    const tabs = process.querySelector('[data-project-tabs]');
    const scroller = tabs?.querySelector('[data-project-tabs-scroll]');
    const links = [...(tabs?.querySelectorAll('a[href^="#"]') || [])];
    const sections = links.map(link => document.getElementById(link.hash.slice(1)));
    if (tabs && scroller && sections.every(Boolean)) {
      let pending = false;
      let activeIndex = -1;
      let stickyTop = 0;
      let tabsHeight = 0;
      const sectionTop = section => section.getBoundingClientRect().top + (parseFloat(getComputedStyle(section).paddingTop) || 0);
      const centerLink = (link, behavior = reduced ? 'instant' : 'smooth') => {
        const left = link.offsetLeft - scroller.offsetLeft - (scroller.clientWidth - link.offsetWidth) / 2;
        scroller.scrollTo({left, behavior});
      };
      const measureHeader = () => {
        const candidates = [document.getElementById('shopify-section-header'), document.getElementById('mobileNavBar'), document.querySelector('.site-header')];
        if (innerWidth >= 1100) candidates.push(document.getElementById('navBar'));
        return candidates.reduce((bottom, node) => {
          if (!node) return bottom;
          const style = getComputedStyle(node);
          const rect = node.getBoundingClientRect();
          if (!['sticky', 'fixed'].includes(style.position) || style.display === 'none' || style.visibility === 'hidden' || rect.top > 1 || rect.bottom <= 0) return bottom;
          return Math.max(bottom, rect.bottom);
        }, 0);
      };
      const update = () => {
        pending = false;
        const nextTop = measureHeader();
        const nextHeight = tabs.getBoundingClientRect().height;
        if (nextTop !== stickyTop) { stickyTop = nextTop; root.style.setProperty('--ers-p-sticky-top', `${stickyTop}px`); }
        if (nextHeight !== tabsHeight) { tabsHeight = nextHeight; root.style.setProperty('--ers-p-tabs-height', `${tabsHeight}px`); }
        let index = 0;
        sections.forEach((section, i) => { if (sectionTop(section) <= stickyTop + tabsHeight + 36) index = i; });
        if (index !== activeIndex) {
          activeIndex = index;
          links.forEach((link, i) => { if (i === index) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); });
          if (tabs.getBoundingClientRect().top <= stickyTop + 1) centerLink(links[index]);
        }
      };
      const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
      update();
      window.addEventListener('scroll', schedule, {passive: true});
      window.addEventListener('resize', schedule, {passive: true});
      window.addEventListener('hashchange', schedule);
      if ('ResizeObserver' in window) {
        const resize = new ResizeObserver(schedule);
        resize.observe(tabs);
        const header = document.getElementById('mobileNavBar');
        if (header) resize.observe(header);
      }
      process.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        const target = link && document.getElementById(link.hash.slice(1));
        if (!target || !process.contains(target)) return;
        event.preventDefault();
        update();
        history.pushState(null, '', link.hash);
        const top = sectionTop(target) + scrollY - stickyTop - tabsHeight - 24;
        window.scrollTo({top, behavior: reduced ? 'instant' : 'smooth'});
        if (tabs.contains(link)) {
          const title = target.querySelector('h2');
          if (title) { title.tabIndex = -1; title.focus({preventScroll: true}); }
          centerLink(link);
        }
        schedule();
      });
      tabs.addEventListener('keydown', event => {
        const index = links.indexOf(event.target.closest('a'));
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % links.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + links.length) % links.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = links.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        links[next].focus({preventScroll: true});
        centerLink(links[next]);
      });
    }
  }
  const isProtectedImageEvent = event => {
    if (!(event.target instanceof Element)) return false;
    const media = event.target.closest('[data-protect-image]') || event.target.closest('.ers-p__project')?.querySelector('[data-protect-image]');
    if (!media) return false;
    if (media.contains(event.target)) return true;
    const bounds = media.querySelector('.ers-p-media__frame').getBoundingClientRect();
    return event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
  };
  document.addEventListener('contextmenu', event => {
    if (isProtectedImageEvent(event)) event.preventDefault();
  });
  document.addEventListener('dragstart', event => {
    if (isProtectedImageEvent(event)) event.preventDefault();
  });
  const initializeProjectDialog = container => {
    const projectDialog = container.querySelector('[data-project-dialog]');
    if (!projectDialog || projectDialog.dataset.initialized || typeof projectDialog.showModal !== 'function') return;
    projectDialog.dataset.initialized = 'true';
    const projectSection = projectDialog.closest('section');
    projectSection.dataset.projectDialogReady = 'true';
    projectSection.querySelectorAll('[data-project-modal-open]').forEach(button => { button.disabled = false; });
    const title = projectDialog.querySelector('[data-project-dialog-title]');
    const content = projectDialog.querySelector('[data-project-dialog-content]');
    let trigger;
    projectSection.addEventListener('click', event => {
      const button = event.target.closest('[data-project-modal-open]');
      const details = button?.closest('.ers-p__project')?.querySelector('[data-project-details]');
      if (!button || !details || button.getAttribute('aria-controls') !== projectDialog.id) return;
      trigger = button;
      title.textContent = button.dataset.projectTitle;
      content.replaceChildren(...[...details.childNodes].map(node => node.cloneNode(true)));
      projectDialog.showModal();
      document.documentElement.classList.add('ers-p-project-dialog-open');
    });
    projectDialog.querySelector('[data-project-dialog-close]').addEventListener('click', () => projectDialog.close());
    projectDialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const focusable = [...projectDialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter(node => node.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    projectDialog.addEventListener('click', event => {
      if (event.target !== projectDialog) return;
      const bounds = projectDialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) projectDialog.close();
    });
    projectDialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ers-p-project-dialog-open');
      content.replaceChildren();
      trigger?.focus({preventScroll: true});
    });
  };
  initializeProjectDialog(root);
  document.addEventListener('shopify:section:load', event => initializeProjectDialog(event.target));
  root.querySelectorAll('[data-project-view-controls]').forEach(controls => {
    const list = root.querySelector('[data-project-list]');
    if (!list) return;
    controls.hidden = false;
    controls.addEventListener('click', event => {
      const button = event.target.closest('button[data-project-view]');
      if (!button) return;
      const mode = button.dataset.projectView;
      list.classList.toggle('ers-p__project-list--list', mode === 'list');
      controls.querySelectorAll('button').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
      const status = root.querySelector('[data-project-view-status]');
      if (status) status.textContent = `${mode === 'list' ? 'List' : 'Grid'} view selected.`;
    });
  });
  const dialog = root.querySelector('[data-case-lightbox]');
  if (dialog && typeof dialog.showModal === 'function') {
    const figures = [...root.querySelectorAll('[data-editorial-media]')];
    const records = figures.map(figure => {
      const img = figure.querySelector('img');
      return {src: img.currentSrc || img.src, srcset: img.getAttribute('srcset') || '', alt: img.alt, caption: figure.querySelector('figcaption > span')?.textContent.trim() || ''};
    });
    const viewerImage = dialog.querySelector('[data-case-lightbox-image]');
    const viewerCaption = dialog.querySelector('[data-case-lightbox-caption]');
    const count = dialog.querySelector('[data-case-lightbox-count]');
    let selected = 0;
    let heroSelected = 0;
    let lastTrigger;
    let change = 0;
    const apply = (image, record) => {
      image.src = record.src;
      if (record.srcset) image.srcset = record.srcset; else image.removeAttribute('srcset');
      image.alt = record.alt;
    };
    const show = index => {
      selected = (index + records.length) % records.length;
      apply(viewerImage, records[selected]);
      viewerCaption.textContent = records[selected].caption;
      count.textContent = `${selected + 1} / ${records.length}`;
    };
    const open = (index, trigger) => {
      lastTrigger = trigger;
      show(index);
      dialog.showModal();
      document.documentElement.classList.add('ers-p-lightbox-open');
    };
    figures.forEach((figure, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ers-p__media-open';
      button.textContent = 'View image';
      button.setAttribute('aria-label', `Open project media ${index + 1}`);
      button.addEventListener('click', () => open(index === 0 ? heroSelected : index, button));
      figure.querySelector('.ers-p-media__frame').append(button);
    });
    dialog.querySelector('[data-case-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-case-lightbox-previous]').addEventListener('click', () => show(selected - 1));
    dialog.querySelector('[data-case-lightbox-next]').addEventListener('click', () => show(selected + 1));
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ers-p-lightbox-open');
      lastTrigger?.focus({preventScroll: true});
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); show(selected + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(selected - 1); }
    });
    let touch;
    dialog.addEventListener('pointerdown', event => { touch = {x: event.clientX, y: event.clientY}; });
    dialog.addEventListener('pointerup', event => {
      if (!touch) return;
      const dx = event.clientX - touch.x, dy = event.clientY - touch.y;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) show(selected + (dx < 0 ? 1 : -1));
      touch = null;
    });
    const controls = root.querySelector('[data-case-cover-controls]');
    if (controls && records.length > 1) {
      controls.hidden = false;
      const heroImage = figures[0].querySelector('img');
      const heroCaption = figures[0].querySelector('figcaption > span');
      const cycleHero = async direction => {
        const token = ++change;
        heroSelected = (heroSelected + direction + records.length) % records.length;
        const record = records[heroSelected];
        const preload = new Image(); preload.src = record.src;
        await preload.decode().catch(() => {});
        if (token !== change) return;
        apply(heroImage, record);
        heroCaption.textContent = record.caption;
        if (!reduced) heroImage.animate([{opacity: .2}, {opacity: 1}], {duration: 550, easing: 'ease-out'});
      };
      root.querySelector('[data-case-previous]').addEventListener('click', () => cycleHero(-1));
      root.querySelector('[data-case-next]').addEventListener('click', () => cycleHero(1));
    }
  }
})();
